import React, { useEffect, useRef, useState } from 'react';
import { Loader2 } from 'lucide-react';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const API_URL = process.env.REACT_APP_BACKEND_URL || '';

const GoogleAuthCallback = () => {
  const processed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || '';
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;

    if (!sessionId) {
      window.location.replace('/login');
      return;
    }

    (async () => {
      try {
        const res = await fetch(`${API_URL}/api/auth/google/session`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ session_id: sessionId })
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.detail || 'Google sign-in failed');
        localStorage.setItem('token', data.token);
        window.location.replace('/customer');
      } catch (err) {
        setError(err.message);
        setTimeout(() => window.location.replace('/login'), 2500);
      }
    })();
  }, []);

  return (
    <div className="min-h-screen bg-black flex items-center justify-center" data-testid="google-auth-callback">
      <div className="text-center">
        {error ? (
          <p className="text-red-400 text-sm" data-testid="google-auth-error">{error}</p>
        ) : (
          <>
            <Loader2 className="w-8 h-8 text-red-500 animate-spin mx-auto mb-3" />
            <p className="text-gray-400 text-sm">Signing you in with Google...</p>
          </>
        )}
      </div>
    </div>
  );
};

export default GoogleAuthCallback;
